// removed by extract-text-webpack-plugin
module.exports = {"ctaContainer":"G3257ab","ctaContainerPaddingReset":"Gc92cc0","nextDelivery":"G0d5619"};